<template>
  <div class="homescreen" :style="color">
    <div class="homeprofile">
      <div class="homeheader columns is-mobile">
        <div class="column is-3">
          <a @click="router('/profile')">
            <div
              v-bind:style="{ 'background-image': image }"
              v-if="$store.state.profile.picture === ''"
              class="homeprofileimg"
            ></div>
            <div
              :style="$store.state.profile.picture"
              v-else
              class="homeprofileimg"
            ></div>
          </a>
        </div>
        <div class="column is-7">
          <h6 class="home title" :style="textColor">
            Hi
            <span>
              <span
                v-if="$store.state.profile.fname === ''"
                class="preload"
                style="width: 100px"
              ></span>
              <span v-else>{{ $store.state.profile.fname }}</span>
            </span>
            <img src="../assets/img/hi.png" width="28px" />
          </h6>
        </div>
        <div class="column is-2">
          <a @click="router('/search')" class="searchIcon">
            <i class="fas fa-search"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="columns featured is-mobile">
        <div class="column">
          <div
            @click="$router.push(bannerRoute)"
            class="card depth2"
            v-bind:style="{ 'background-image': banner }"
          >
            <div class="featured-banner">Participate</div>
            <h6 class="featured-headline" style="font-size: 1.25rem">
              {{ bannerText }}
            </h6>
          </div>
        </div>
      </div>
      <div class="columns">
        <div v-if="submissionexist" class="columns">
          <div class="column">
            <h6 class="preview-headline subtitle has-text-centered">
              My Submissions
            </h6>
            <div class="column">
              <img
                @click="$router.push('/submission')"
                :src="submissionBanner"
              />
            </div>
            <!-- <div class="columns is-mobile submissions">
            <div
              v-for="theme in submittedthemes"
              :key="theme.id"
              @click="showSubmisison(theme.id)"
              class="column is-3"
            >
              <img :src="theme.img" />
            </div>
          </div> -->
          </div>
        </div>
        <!-- <div class="columns">
        <div class="column">
          <h6 class="preview-headline subtitle has-text-centered">
            Select a theme to participate
          </h6>
        </div>
      </div>
      <div class="themes">
        <div v-for="card in themes" :key="card.id" class="themecard">
          <img @click="router('/theme/' + card.id)" :src="card.img" />
        </div>
      </div> -->
        <hr />
        <div class="columns">
          <div class="column">
            <h6 class="preview-headline subtitle has-text-centered">
              Learn More
            </h6>
          </div>
        </div>
        <div class="themes">
          <div class="themecard" v-if="content.timeline">
            <img @click="timeline = true" :src="contents.timeline" />
          </div>
          <div class="themecard" v-if="content.rules">
            <img @click="rules = true" :src="contents.rules" />
          </div>
          <div class="themecard" v-if="content.faqs">
            <img @click="faqs = true" :src="contents.faqs" />
          </div>
          <div class="themecard" v-if="content.eligibility">
            <img @click="eligibility = true" :src="contents.eligibility" />
          </div>
          <div class="themecard" v-if="content.prizes">
            <img @click="prizes = true" :src="contents.prizes" />
          </div>
        </div>
        <hr />
        <div class="columns">
          <div class="column">
            <h6 class="preview-headline subtitle has-text-centered">
              Get Help
            </h6>
          </div>
          <div class="column">
            <div class="scrollingwrapper">
              <a
                @click="router(card.route)"
                class="scrolling-card"
                :key="card.banner"
                v-for="card in recommended"
              >
                <v-lazy-image
                  :src-placeholder="require('@/assets/img/home-lazy.png')"
                  :src="card.banner"
                />
              </a>
            </div>
          </div>
        </div>
        <div class="column">
          <a @click="shareIt" class="button is-fullwidth shareIt">Share It</a>
        </div>
      </div>
      <div class="columns">
        <div class="column" style="padding-top: 50px"></div>
      </div>
      <!-- submission
      <div v-if="submissionbox" class="tfcontent modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Your Submission</p>
            <button
              @click="submissionbox = false"
              class="delete"
              aria-label="close"
            ></button>
          </header>
          <div class="modal-card-body">
            <h3 class="subtitle">Idea</h3>
            <p>
              <b>Title: </b> {{ submission.title }} <br /><br />
              <b>Description: </b>
              <br />
              {{ submission.desc }}
            </p>
            <hr />
            <h3 class="subtitle">Status</h3>
            <div class="notification is-primary is-light">
              <span v-html="submission.status"></span>
            </div>
             <hr />
            <h3 class="subtitle">Recommendation</h3>
            <div class="scrollingwrapper">
              <a
                @click="router('/project/' + project.id)"
                class="scrolling-card"
                :key="project.index"
                v-for="project in submission.recommendation"
              >
                <v-lazy-image
                  :src-placeholder="require('@/assets/img/home-lazy.png')"
                  :src="project.image"
                  @error="
                    post.thumbnail = require('@/assets/img/home-lazy.png')
                  "
                />
              </a>
            </div>
            <hr />
            <h3 class="subtitle">Submitted Video</h3>
            <video-player
              v-if="vid1.loaded"
              class="vjs-custom-skin"
              ref="videoPlayer"
              :options="vid1"
              :playsinline="true"
            ></video-player>
            <p v-else>You have not uploaded a video yet.</p>
            <hr />
            <h3 class="subtitle">Team</h3>
            <p>
              <b>#1: </b>{{ submission.team1.name }} <br />
              {{ submission.team1.email }}<br /><br />
              <b>#2: </b>{{ submission.team2.name }} <br /><br />
              {{ submission.team2.email }}<br /><br />
              <b>#3: </b>{{ submission.team3.name }}<br />
              {{ submission.team1.email }}<br /><br />
            </p>
          </div>
          <footer class="modal-card-foot">
            <button
              v-if="submission.stage != 4 && submission.stage != 5"
              class="button"
              @click="router('/theme/' + submission.theme)"
            >
              Go To Theme
            </button>
            <button
              v-if="submission.stage === 4"
              class="button"
              @click="router('/upload/story/' + submission.theme + '/0')"
            >
              Upload Video
            </button>
            <button
              v-if="submission.stage === 5"
              class="button"
              @click="router('/upload/story/' + submission.theme + '/0')"
            >
              Re-Upload Video
            </button>
          </footer>
        </div>
      </div>
       /submission -->
      <!-- how-to-participate -->
      <div v-if="htp" class="tfcontent modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">How to Participate</p>
            <button
              @click="htp = false"
              class="delete"
              aria-label="close"
            ></button>
          </header>
          <section class="modal-card-body" v-html="content.htp"></section>
          <footer class="modal-card-foot">
            <button class="button" @click="htp = false">Done</button>
          </footer>
        </div>
      </div>
      <!-- /how-to-participate -->
      <!-- rules -->
      <div v-if="rules" class="tfcontent modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Rules</p>
            <button
              @click="rules = false"
              class="delete"
              aria-label="close"
            ></button>
          </header>
          <section class="modal-card-body">
            <!-- <div class="video-container">
              <video-player
                v-if="vid1.loaded"
                class="vjs-custom-skin"
                ref="videoPlayer"
                :options="vid1"
                :playsinline="true"
              ></video-player>
            </div> -->
            <div v-html="content.rules"></div>
          </section>
          <footer class="modal-card-foot">
            <button class="button" @click="rules = false">Done</button>
          </footer>
        </div>
      </div>
      <!-- /rules -->
      <!-- eligibility -->
      <div v-if="eligibility" class="tfcontent modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Eligibility</p>
            <button
              @click="eligibility = false"
              class="delete"
              aria-label="close"
            ></button>
          </header>
          <section
            class="modal-card-body"
            v-html="content.eligibility"
          ></section>
          <footer class="modal-card-foot">
            <button class="button" @click="eligibility = false">Done</button>
          </footer>
        </div>
      </div>
      <!-- /eligibility -->
      <!-- prizes -->
      <div v-if="prizes" class="tfcontent modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Eligibility</p>
            <button
              @click="prizes = false"
              class="delete"
              aria-label="close"
            ></button>
          </header>
          <section class="modal-card-body" v-html="content.prizes"></section>
          <footer class="modal-card-foot">
            <button class="button" @click="prizes = false">Done</button>
          </footer>
        </div>
      </div>
      <!-- /prizes -->
      <!-- timeline -->
      <div v-if="timeline" class="tfcontent modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Timeline</p>
            <button
              @click="timeline = false"
              class="delete"
              aria-label="close"
            ></button>
          </header>
          <section class="modal-card-body" v-html="content.timeline"></section>
          <footer class="modal-card-foot">
            <button class="button" @click="timeline = false">Done</button>
          </footer>
        </div>
      </div>
      <!-- /timeline -->
      <!-- faqs -->
      <div v-if="faqs" class="tfcontent modal is-active">
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">FAQs</p>
            <button
              @click="faqs = false"
              class="delete"
              aria-label="close"
            ></button>
          </header>
          <section class="modal-card-body" v-html="content.faqs"></section>
          <footer class="modal-card-foot">
            <button class="button" @click="faqs = false">Done</button>
          </footer>
        </div>
      </div>
      <!-- /faqs -->
    </div>
  </div>
</template>
<script>
// import { Plugins } from "@capacitor/core";
import { auth } from "@/main.js";
import { db } from "@/main.js";
// const { App } = Plugins;
import VLazyImage from "v-lazy-image";
import "@/assets/css/video-js.css";
import { Share } from "@capacitor/share";
// import { videoPlayer } from "vue-video-player";
export default {
  name: "fest",
  components: {
    VLazyImage,
    // videoPlayer,
  },
  //   components: {
  //     VLazyImage,
  //     videoPlayer,
  //   },
  data() {
    return {
      submissionBanner: "",
      screen: "home2",
      projectstatus: true,
      fname: "",
      image: "url(" + require("@/assets/img/user.png") + ")",
      picture: "",
      banner: "",
      bannerRoute: "",
      bannerText: "",
      coins: 0,
      themes: [],
      contents: {},
      submissionbox: false,
      submissionexist: false,
      vid1: {
        height: "100%",
        width: "100%",
        autoplay: true,
        muted: false,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        poster:
          "https://surmon-china.github.io/vue-quill-editor/static/images/surmon-1.jpg",
        loaded: true,
        sources: [
          {
            type: "video/mp4",
            src: "https://firebasestorage.googleapis.com/v0/b/witblox-5ae68.appspot.com/o/projects%2Firon-man-helmet%2Ftrailer.mp4?alt=media&token=22d1fdaa-171b-40a0-95b6-9ee01b718b14",
          },
        ],
      },
      videoexist: false,
      submission: {
        theme: "",
        id: "",
        title: "",
        desc: "",
        status: "",
        recommendation: [],
        team1: {
          name: "",
          email: "",
        },
        team2: {
          name: "",
          email: "",
        },
        team3: {
          name: "",
          email: "",
        },
      },
      submittedthemes: [],
      rules: false,
      eligibility: false,
      timeline: false,
      faqs: false,
      htp: false,
      prizes: false,
      content: {
        timeline: "",
        rules: "",
        faqs: "",
        eligibility: "",
        htp: "",
        prizes: "",
      },
      headerMsg: "",
      recommended: [],
    };
  },
  methods: {
    router(name) {
      this.$router.push(name);
    },
    getColor() {
      this.$store.commit("getColorInfo");
      this.color =
        "background: linear-gradient(360deg, #ffffff 0%, #ffffff 82%, " +
        this.$store.state.selectedColor.c1 +
        " 100%);";
      this.textColor = "color: " + this.$store.state.selectedColor.c2 + ";";
    },
    async shareIt() {
      await Share.share({
        title: "Check this competition on WitBlox",
        text: "Check out this competition from WitBlox.",
        url: "https://witblox.com/irc",
        dialogTitle: "Share with friends",
      });
    },
    showSubmisison(id) {
      console.log(id);
      this.vid1.sources = [];
      this.vid1.loaded = false;
      this.submissionbox = true;
      this.submission.id = id;
      db.collection("config")
        .doc("irc")
        .collection("submissions")
        .doc(id)
        .get()
        .then((doc) => {
          this.submission.theme = doc.data().theme;
          this.submission.title = doc.data().idea.title;
          this.submission.desc = doc.data().idea.desc;
          this.submission.team1.name = doc.data().team[0].name;
          this.submission.team1.email = doc.data().team[0].email;
          this.submission.team2.name = doc.data().team[1].name;
          this.submission.team2.email = doc.data().team[1].email;
          this.submission.team3.name = doc.data().team[2].name;
          this.submission.team3.email = doc.data().team[2].email;
          this.submission.stage = doc.data().stage;
          this.submission.recommendation = [];
          auth.onAuthStateChanged((user) => {
            db.collection("social")
              .where("tag", "==", doc.data().theme)
              .where("uid", "==", user.uid)
              .get()
              .then((snap) => {
                if (!snap.empty) {
                  this.vid1.sources.push({
                    type: "video/mp4",
                    src: snap.docs[0].data().url,
                  });
                  this.vid1.loaded = true;
                } else console.log("no video");
              });
          });
          db.collection("config")
            .doc("irc")
            .collection("themes")
            .doc(doc.data().theme)
            .get()
            .then((doc2) => {
              //   doc2.data().projects.forEach((project) => {
              //     db.collection("projects")
              //       .doc(project)
              //       .get()
              //       .then((prjct) => {
              //         this.submission.recommendation.push({
              //           id: prjct.id,
              //           image: prjct.data().featuredImg,
              //         });
              //       });
              //   });
              this.submission.status = doc2.data().status[doc.data().stage];
            });
        });
    },
  },
  beforeMount() {
    this.getColor();
    db.collection("config")
      .doc("irc")
      .get()
      .then((doc) => {
        console.log(doc.data(), doc.data().contents);
        this.headerMsg = doc.data().headerMsg;
        this.content.htp = doc.data().htp;
        this.content.timeline = doc.data().timeline;
        this.content.rules = doc.data().rules;
        this.content.faqs = doc.data().faqs;
        this.content.eligibility = doc.data().eligibility;
        this.content.prizes = doc.data().prizes;
        this.contents = doc.data().contents;
        this.recommended = doc.data().recommended;
        this.banner = "url(" + doc.data().inthemebanner + ")";
        this.bannerRoute = doc.data().inthemebanner_route;
        this.bannerText = doc.data().inthemebanner_text;
        this.submissionBanner = doc.data().submissionBanner;
      });
    db.collection("config")
      .doc("irc")
      .collection("themes")
      .get()
      .then((snap) => {
        snap.forEach((doc) => {
          this.themes.push({
            id: doc.id,
            img: doc.data().banner,
          });
        });
      });
    auth.onAuthStateChanged((user) => {
      db.collection("shop-orders")
        .where("uid", "==", user.uid)
        .get()
        .then((snap) => {
          snap.forEach((orders) => {
            if (!this.paid) {
              orders.data().products.forEach((product) => {
                if (!this.paid)
                  if (product.id == "4kZxGIE2wTTwowSrffLv") {
                    this.paid = true;
                    if (orders.id) {
                      db.collection("config")
                        .doc("irc")
                        .collection("submissions")
                        .where("uid", "==", user.uid)
                        .get()
                        .then((submission) => {
                          db.collection("config")
                            .doc("irc")
                            .collection("submissions")
                            .doc(submission.docs[0].id)
                            .update({
                              orderId: orders.id,
                            });
                        });
                    }
                  }
              });
            }
          });
        });
      this.fname = user.displayName;
      if (user.photoURL) {
        this.picture =
          "background: url(" +
          user.photoURL +
          "), linear-gradient(to right, rgb(142, 45, 226), rgb(74, 0, 224))";
      }
      db.collection("config")
        .doc("irc")
        .collection("submissions")
        .where("uid", "==", user.uid)
        .get()
        .then((snap) => {
          this.submissionexist = !snap.empty;
          snap.forEach((doc) => {
            db.collection("config")
              .doc("irc")
              .collection("themes")
              .doc(doc.data().theme)
              .get()
              .then((doc2) => {
                console.log(doc2.data());
                this.submittedthemes.push({
                  id: doc.id,
                  img: doc2.data().banner,
                });
              });
          });
        });
    });
  },
};
</script>
<style scoped>
ul,
ol {
  padding-left: 30px;
}
.video-container {
  height: 300px;
  padding-bottom: 50px;
}
.modal-card-foot .button {
  background: #fff;
  color: #000;
  border: 2px solid #000;
  border-radius: 10px;
  font-family: "Poppins", sans-serif;
}
.shareIt {
  background: #fff;
  border: none;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.14) 0px 24px 38px 3px,
    rgba(0, 0, 0, 0.12) 0px 9px 46px 8px, rgba(0, 0, 0, 0.2) 0px 11px 15px -7px;
}
</style>